export function LoadingState({ label = "Preparing your estimate" }: { label?: string }) {
  return (
    <section className="loading-state" role="status" aria-live="polite">
      <p className="eyebrow">Please wait</p>
      <h1>{label}</h1>
      <div className="skeleton skeleton--wide" aria-hidden="true" />
      <div className="estimate-grid" aria-hidden="true"><div className="skeleton" /><div className="skeleton" /></div>
    </section>
  );
}
